import React from 'react';

/**
 * Lets the header's hamburger open the mobile nav drawer that `App` owns.
 *
 * Deliberately its own module rather than an export from `App.tsx`: `App` imports `MainHeader`,
 * so exporting it from `App` would make the two files import each other, and a cyclic import
 * resolves the context to its default value — a hamburger that renders and does nothing.
 */
export const NavDrawerContext = React.createContext<{ openDrawer: () => void }>({ openDrawer: () => {} });
